import React from "react";
import { Tag, Typography } from "antd";
import { useActionDefaultDebugRefine } from "hook/base/debug/useActionDefaultDebug";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DebugHeader = () => {
  // -------------------------- VAR -----------------------------
  const { total } = useActionDefaultDebugRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div>
      <Typography.Title style={{ margin: "0px" }} level={4}>
        Danh sách debug job{" "}
        <Tag style={{ borderRadius: 30 }}>Total: {total}</Tag>
      </Typography.Title>
      <Typography.Text type="secondary">
        Kết quả debug sẽ hiển thị trong màn hình này
      </Typography.Text>
    </div>
  );
};
export default DebugHeader;
